import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AppTranslateService} from '../../../modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {AppeloffreService} from 'src/app/modules/services/appel-offre/appeloffre.service';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {vappeloffre, vconsultation} from 'src/app/domain';
import {SearchOptions} from 'src/app/domain/offre';
import {SearchObjectService} from 'src/app/modules/services/search-object/SearchObjectService';
import {ConsultationService} from 'src/app/modules/services/consultation/consultation.service';

export interface SearchView<T> {
    loading: boolean;
    options: any;
    count: number;
    results: T[];
}

@Component({
    selector: 'app-accueil',
    templateUrl: './accueil.component.html',
    styleUrls: ['./accueil.component.css'],
})
export class AccueilComponent implements OnInit {
    key = 'access_token';
    visib: boolean = false;
    offers: vappeloffre[] = [];
    searchOptions?: Partial<SearchOptions>;
    searchObject: SearchObject;

    searchObjectConsultation: SearchObject;
    count: number;

    searchh: SearchView<vappeloffre> = {
        loading: false,
        options: undefined,
        count: 0,
        results: [],
    };
    listConsultations: SearchView<vconsultation> = {
        loading: false,
        options: undefined,
        count: 0,
        results: [],
    };
    isLoading = {
        list: false,
    };
    isLoadingConsultation = {
        list: false,
    };
    slides: any = [[]];
    slidesConsultation: any = [[]];

    constructor(
        public appTranslateService: AppTranslateService,
        private titleService: Title,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService,
        private router: Router,
        private searchObjectService: SearchObjectService,
        private offerservice: AppeloffreService,
        private toast: ToastService,
        private consultationservice: ConsultationService
    ) {
    }

    ngOnInit(): void {


        if (this.router.url.toString() == '/portail') {
            this.visib = true;
        } else {
            this.visib = false;
        }
        this.appTranslateService.useLanguage();
        // this.setupTitle();
        // sessionStorage.removeItem('_expiredTime');
        // this.searchObject = this.searchObjectService.treatementSearchObject(
        //     10,
        //     0,
        //     null,
        //     null
        // );
        // this.initDataList();

        // this.searchObjectConsultation = this.searchObjectService.treatementSearchObject(
        //     10,
        //     0,
        //     null,
        //     null
        // );
        // this.initDataListConsultations();
    }

    initDataList() {
        this.isLoading.list = true;
        this.searchObject = this.searchObjectService.treatementSearchObject(
            10,
            0,
            'publicDt',
            'desc nulls last'
        );
        this.offerservice.search(this.searchObject).subscribe({
            next: (response) => {

                this.searchh.results = response['payload']['data'];
                this.searchh.count = response['payload']['total'];
                this.slides = this.chunk(response['payload']['data'], 4);
            },
            error: () => {
                this.isLoading.list = false;
                this.toast.error('server_error');
            },
            complete: () => {
                this.isLoading.list = false;
            },
        });
    }

    chunk(arr, chunkSize) {
        let R = [];
        for (let i = 0, len = arr.length; i < len; i += chunkSize) {
            R.push(arr.slice(i, i + chunkSize));
        }
        return R;
    }

    initDataListConsultations() {
        this.isLoadingConsultation.list = true;
      this.searchObjectConsultation = this.searchObjectService.treatementSearchObject(
            10,
            0,
            'publicDt',
            'desc nulls last'
        );
        this.consultationservice.search(this.searchObjectConsultation).subscribe({
            next: (response) => {
                this.listConsultations.results = response['payload']['data'];
                this.listConsultations.count = response['payload']['total'];
                // this.listConsultations.results.filter((column) => column.publicDt=  .format("YYYY-MM-DD");;

                this.slidesConsultation = this.chunkConsultation(
                    response['payload']['data'],
                    4
                );
            },
            error: () => {
                this.isLoading.list = false;
                this.toast.error('server_error');
            },
            complete: () => {
                this.isLoading.list = false;
            },
        });
    }

    chunkConsultation(arr, chunkSize) {
        let R = [];
        for (let i = 0, len = arr.length; i < len; i += chunkSize) {
            R.push(arr.slice(i, i + chunkSize));
        }
        return R;
    }
}
